import React from "react"
import Article from '../Article'

function Introduction(props) {

  const content = `<p><strong>Totem Smart Store Dexco</strong> &eacute; um servi&ccedil;o digital para simular ambientes em tempo real para o consumidor e promotor Dexco durante a Jornada do Consumidor na web e no ponto de venda Dexco. &Eacute; uma experi&ecirc;ncia inteligente e facilitadora para o consumidor Dexco no ponto de venda.<br />
  <p>&nbsp;</p>
  J&aacute; a <strong>Smart Tool</strong> &eacute; o agrupamento das fun&ccedil;&otilde;es &ldquo;Simular&rdquo; que simula ambientes em tempo real para o consumidor Dexco durante sua Jornada nos sites <strong>Portinari</strong>, <strong>Ceusa</strong> e <strong>Durafloor</strong> (Meu Piso Ideal).&nbsp;</p>
  `

  return (
    <Article article={content} title='Introdução' />
    )
  
}

export default Introduction
